(ns frontend.view.task.email.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :email-task-resolution]))
(defonce temp-state (r/cursor state [:temp-values]))

(defonce timeout-state (atom {}))
